import { useSnackbarMessageActionsContext } from "../context";

export const useAddSnackbarMessage = () => {
  const context = useSnackbarMessageActionsContext();

  if (!context) {
    throw new Error(
      "useAddSnackbarMessage must be used within a SnackbarMessageActionsContext",
    );
  }

  return context.addMessage;
};
